module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_04-193c0e785f437a3b5ed9a36457b45798.jpg";